import {from, Observable} from "rxjs"
import * as OBS from "fp-ts-rxjs/Observable"
import {pipe} from "fp-ts/function"
import {
    EnrollmentConstraints,
    EnrollmentParameters,
    IEnrollment,
    ValidateEnrollmentsRequest
} from "../model/enrollment.model"
import API from "../api"


const BASE_PATH = 'enrollment'

export const fetchConfirmedEnrollments = (schoolId: number, enrollmentId: number): Observable<ReadonlyArray<IEnrollment>> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/allConfirmed", {
                params: {
                    schoolId,
                    enrollmentId
                }
            })
        ),
        OBS.map((res):ReadonlyArray<IEnrollment> => res.data)
    )
}

export const fetchNotConfirmedEnrollments = (schoolId: number, enrollmentId: number): Observable<ReadonlyArray<IEnrollment>> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/allNotConfirmed", {
                params: {
                    schoolId,
                    enrollmentId
                }
            })
        ),
        OBS.map((res):ReadonlyArray<IEnrollment> => res.data)
    )
}

export const getEnrollmentClassesByEnrollmentId = (enrollmentId: number): Observable<ReadonlyArray<string>> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/enrollmentClasses", {
                params: {
                    enrollmentId
                }
            })
        ),
        OBS.map((res): ReadonlyArray<string> => res.data)
    )
}

export const checkEnrollmentClassesByFiscalCode = (fiscalCode: string): Observable<EnrollmentConstraints | undefined> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/checkFiscalCode", {
                params: {
                    fiscalCode
                }
            })
        ),
        OBS.map((res): (EnrollmentConstraints | undefined) => res.data)
    )
}

export const getEnrollmentParametersByEnrollmentId = (enrollmentId: number): Observable<EnrollmentParameters> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/parameters", {
                params: {
                    enrollmentId
                }
            })
        ),
        OBS.map((res): EnrollmentParameters => res.data)
    )
}

export const getEnrollmentsCost = (enrollmentId: string, transientId: string): Observable<number> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/cost", {
                params: {
                    enrollmentId,
                    transientId
                }
            })
        ),
        OBS.map((res): number => res.data)
    )
}

export const getEnrollmentParameters = (): Observable<ReadonlyArray<EnrollmentParameters>> => {
    return pipe(
        from(
            API.get(BASE_PATH + "/allParameters")
        ),
        OBS.map((res): ReadonlyArray<EnrollmentParameters> => res.data)
    )
}

export const validateEnrollments = (request: ValidateEnrollmentsRequest, schoolId: number): Observable<string> => {
    return pipe(
        from(
            API.post(BASE_PATH + "/validate", request, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                params: {
                    schoolId
                }
            })
        ),
        OBS.map((res): string => res.data)
    )
}

export const confirmEnrollments = (schoolId: number, transient_id: string): Observable<void> => {
    return pipe(
        from(
            API.post(BASE_PATH + "/confirm", {}, {
                params: {
                    schoolId,
                    transient_id
                }
            })
        ),
        OBS.map((res) => res.data)
    )
}

